import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/place-an-order',
      name: 'admin-place-an-order',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-place-an-order" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "下单"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "下单"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
